import { useEffect, useState } from "react";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import logo from "../assets/logo/fci_logo.png";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header id="Home">
      <Navbar
        collapseOnSelect
        expand="md"
        className={`navbar-overlay ${scrolled ? "navbar-scrolled" : ""}`}
        fixed="top"
      >
        <Container fluid className="section-container">
          <Navbar.Brand
            as="a"
            href="#home"
            className="d-flex align-items-center"
          >
            <img src={logo} alt="FC Logo" className="fciTech-logo" />
            <span className="logo-text pt-3">techLabs</span>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="responsive-navbar-nav" />

          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link href="#home">Home</Nav.Link>
              <Nav.Link href="#about">About Us</Nav.Link>

              <NavDropdown
                title={
                  <span className="products-dropdown-title">Products</span>
                }
                id="products-dropdown"
                className="products-dropdown"
              >
                <NavDropdown.Item
                  href="https://www.filmcrewindia.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="py-0"
                >
                  FilmCrewIndia
                </NavDropdown.Item>

                <NavDropdown.Divider />

                <NavDropdown.Item
                  href="https://www.myfcpro.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="py-0"
                >
                  FC Pro
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link href="#contact">Contact Us</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
